import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

import * as Common from 'common/components';

const RolesListHeader = ({ companyId = '', t = (key) => key, canAdd = false }) => {
  return (
    <Common.PageHeader title={t('roles.title')}>
      {canAdd && (
        <div className="btn-group pull-right">
          <Link to={`/companies/${companyId}/roles/add`} className="btn btn-info">
            {t('actions.add')}
          </Link>
        </div>
      )}
    </Common.PageHeader>
  );
};

export default translate()(RolesListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/components/RolesListHeader.js